import { Component, computed, inject, input } from '@angular/core';
import { InstallmentStatus, Order } from '../../../../../models/order.model';
import { OrderService } from '../../../../../services/order.service';
import { getDownPaymentStatus } from '../../utils/order-details.util';
import { getDownPaymentAttempts } from '../../utils/payment-attempts.util';
import { CurrencyPipe, DatePipe, TitleCasePipe } from '@angular/common';
import { TableModule } from 'primeng/table';
import { TagStatusComponent } from '../../../../../../shared/components/tag-status/tag-status.component';

@Component({
  selector: 'app-order-details-payment',
  imports: [
    DatePipe,
    CurrencyPipe,
    TagStatusComponent,
    TitleCasePipe,
    TableModule,
  ],
  templateUrl: './order-details-payment.component.html',
})
export class OrderDetailsPaymentComponent {
  order = input<Order | null>(null);
  statusText = input<string | null>(null);

  private readonly orderService = inject(OrderService);

  downPaymentTag = computed(() => {
    const status = getDownPaymentStatus(this.order());

    switch (status) {
      case InstallmentStatus.Paid:
      case InstallmentStatus.PartiallyPaid:
        return { status: 'Approved', text: this.describe(status) };
      case InstallmentStatus.Refunded:
        return { status: 'Draft', text: this.describe(status) };
      case InstallmentStatus.Cancelled:
        return { status: 'Cancelled', text: this.describe(status) };
      case InstallmentStatus.Pending:
      case null:
        return { status: 'Pending', text: 'Aguardando pagamento' };
      default:
        return { status: 'Pending', text: this.describe(status) };
    }
  });

  private describe(status: number | null): string {
    return this.orderService.getInstallmentStatusDescription(
      status as InstallmentStatus,
    );
  }

  paymentAttempts = computed(() => getDownPaymentAttempts(this.order()));
}
